import { render, staticRenderFns } from "./HealthySnacks.vue?vue&type=template&id=f749712c&scoped=true"
import script from "./HealthySnacks.vue?vue&type=script&lang=js"
export * from "./HealthySnacks.vue?vue&type=script&lang=js"
import style0 from "./HealthySnacks.vue?vue&type=style&index=0&id=f749712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f749712c",
  null
  
)

export default component.exports